import axios from "axios";
import { useEffect, useState } from "react";
import { BASE_URL } from "../../config";
import { getWord } from "../../utils/functions";
import Loading from "../Common/Loading";
import { useSelector } from "react-redux";

const Addresses = () => {
  const user = useSelector((state) => state.user);
  const [data, setData] = useState({
    userId: user.userdata.id,
    addresses: [],
    loading: false,
  });

  const { userId, addresses, loading } = data;

  const fetchAddresses = async () => {
    try {
      setData((data) => ({ ...data, loading: true }));
      const res = await axios.post(`${BASE_URL}/user/addresses`, {
        userId,
      });
      setData((data) => ({
        ...data,
        addresses: res.data.addresses,
      }));
    } catch (error) {
      console.error("Error fetching addresses:", error);
    } finally {
      setData((data) => ({ ...data, loading: false }));
    }
  };

  const deleteAddress = async (id) => {
    await axios.delete(`${BASE_URL}/user/addresses/${id}`);
    fetchAddresses();
  };

  useEffect(() => {
    fetchAddresses();
  }, []);
  return (
    <>
      <div className="col-md-9">
        <div className="grid-layout wrapper-shop">
          <div className="tf-login-content">
            {loading ? (
              <div className="spinnerInner" />
            ) : addresses.length > 0 ? (
              <>
                <div>
                  {getWord(
                    "The following addresses will be used on the checkout page."
                  )}{" "}
                  <a className="mb-4 border-bottom pb-2">
                    {getWord("Add New Address")}
                  </a>
                </div>
                <div className="box grid-2">
                  {addresses.map((addr) => (
                    <>
                      <div className="widget-facet" key={addr.id}>
                        <div className="facet-title">
                          <span>{addr.title}</span>
                        </div>
                        <div id="categories" className="collapse show">
                          <ul className="list-categoris current-scrollbar mb_36">
                            <li className="cate-item current">
                              {addr.address_str}
                            </li>
                            <li className="cate-item">Ph: {addr.phone}</li>
                          </ul>
                          <button className="tf-btn radius-3 btn-fill btn-icon animate-hover-btn justify-content-center">
                            {getWord("Edit")}
                          </button>{" "}
                          <button
                            className="tf-btn radius-3 btn-fill btn-icon animate-hover-btn justify-content-center"
                            onClick={() => deleteAddress(addr.id)}
                          >
                            {getWord("Delete")}
                          </button>
                        </div>
                      </div>
                    </>
                  ))}
                </div>
              </>
            ) : (
              <>
                <h6 className="text-center">{getWord("No Addresses")}</h6>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Addresses;
